import { render, staticRenderFns } from "./ButtonAction.vue?vue&type=template&id=31a7558d"
import script from "./ButtonAction.vue?vue&type=script&lang=js"
export * from "./ButtonAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports